import React, { useEffect, useState } from "react";
import MainStore from "../../stores/MainStore";

import RatingBar from "./RatingBar";
import BackgroundDiv from "./BackgroundDiv";
import { getAverageFromRatingObject, getTimeDiff } from "../helperfuncs";

const LiveRating = ({
  description,
  onTick,
  icon,
  averageRating,
  field,
  rated,
  tickTiming,
}) => {
  const { tick } = MainStore();
  const [lastRating, setLastRating] = useState(null);
  const [activeRating, setActiveRating] = useState(0);

  useEffect(() => {
    if (activeRating > 0 && tick % tickTiming == 0) {
      if (lastRating) {
        const diff = getTimeDiff(lastRating, Date.now());
        if (diff.seconds > 60) {
          setActiveRating(0);
        }
      }
      const newRatings = {
        ...rated,
        [activeRating]: rated[activeRating] + 1,
      };

      onTick(newRatings, field);
    }
  }, [tick]);

  return (
    <div
      className="divColumn"
      style={{
        border: "3px solid #2f2f2f",
        borderRadius: ".8rem/.5rem",
      }}
    >
      <div
        className="divRow"
        style={{
          position: "relative",
          width: "100%",
          justifyContent: "center",
          paddingTop: "2px",
          paddingBottom: "2px",
        }}
      >
        <BackgroundDiv
          backgroundColor={"#4f4f4f"}
          borderBottom={true}
          opacity={0.8}
        />
        <div
          className="textBold"
          style={{
            fontSize: "15px",
            zIndex: 1,
            color: "white",
            flex: 1,
            textAlign: "center",
          }}
        >
          {description}
        </div>
        <div
          style={{
            backgroundColor: "#afafaf",
            borderRadius: "0.5rem/0.5rem",
            padding: "2px",
            display: "flex   ",
            justifyContent: "center",
            alignContent: "center",
            zIndex: 1,
            marginRight: "2px",
          }}
        >
          <div
            className="textBold"
            style={{
              fontSize: "15px",
              zIndex: 1,
              color: "#2f2f2f",
              marginRight: "4px",
            }}
          >
            {getAverageFromRatingObject(rated, 2)}
          </div>
          <img src={icon} className="icon15" />
        </div>
      </div>
      <div
        className="divRow"
        style={{
          position: "relative",
          paddingBottom: "2px",
          paddingTop: "3px",
          paddingLeft: "5px",
          paddingRight: "5px",
          justifyContent: "center",
        }}
      >
        <BackgroundDiv
          backgroundColor={"#8f8f8f"}
          borderTop={true}
          opacity={0.4}
        />
        <div
          className="divRow"
          style={{
            zIndex: 1,
          }}
        >
          <RatingBar
            rating={activeRating}
            onClick={(r) => {
              setLastRating(Date.now());
              setActiveRating(r);
            }}
            image={icon}
            direction="divRow"
            imageSize="40px"
            fixedHeight={"30px"}
          />
        </div>
      </div>
    </div>
  );
};

export default LiveRating;
